import React from 'react';
import { createPortal } from 'react-dom';

/**
 * IPE 系统确认/提示弹窗（替代 window.alert / window.confirm）。
 * hideCancel=true 时仅展示主按钮，适合保存成功等提示场景。
 */
export default function IpeConfirmDialog({
  open,
  title = '确认',
  message,
  confirmLabel = '确定',
  cancelLabel = '取消',
  hideCancel = false,
  confirmDanger = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  const handleBackdrop = () => {
    if (hideCancel) {
      onConfirm?.();
      return;
    }
    onCancel?.();
  };

  return createPortal(
    <div className="ipe-account-modal" role="presentation" onClick={handleBackdrop}>
      <div
        className="ipe-account-modal__panel ipe-account-modal__panel--compact"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="ipe-confirm-dialog-title"
        onClick={(ev) => ev.stopPropagation()}
      >
        <h2 id="ipe-confirm-dialog-title" className="ipe-account-modal__title">
          {title}
        </h2>
        {message ? <p className="ipe-account-modal__message">{message}</p> : null}
        <div className="ipe-account-modal__actions">
          {hideCancel ? null : (
            <button type="button" className="ipe-account-modal__btn ipe-account-modal__btn--ghost" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            className={`ipe-account-modal__btn${confirmDanger ? ' ipe-account-modal__btn--danger' : ' ipe-account-modal__btn--primary'}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
